// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

/* html,
body {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin: 0;
} */

.admin-panel {
  font-size: 20px;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex-center-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-center-evenly {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 24px;
}

.breadcrumb {
  height: 60px;
  width: 100%;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.breadcrumb-logo-font {
  font-size: 26px;
  text-align: left;
  line-height: 1px;
  padding: 5px;
  font-weight: bold;
}

.breadcrumb-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.breadcrumb-logo {
  width: 250px;
  height: 80px;
  background-color: #ff7d4d;
  color: #fff;
}

.breadcrumb-right-side {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding-right: 20px;
}

.admin-name {
  font-size: 14px;
  color: #252b48;
}

.admin-role {
  font-size: 14px;
  color: #827f86;
}

.admin-name-role {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex-wrap: nowrap;
  align-items: start;
  gap: 4px;
}

.Sidebar-styles.ant-layout-sider {
  min-height: calc(100vh - 60px);
  min-width: 250px;
}

.flex-column-style {
  display: flex;
}

.flex-column-style .flex-grow-content {
  flex-grow: 1;
  min-height: 400px;
  max-height: calc(100vh - 60px);
  overflow-y: scroll;
  scrollbar-width: thin;
}

.dashboard-outer-container {
  height: 90vh;
  overflow-y: auto;
  padding: 20px;
  background-color: #e8edf7;
}

.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #f0f2f5;
}

.login-container {
  width: 350px;
  padding: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.login-form h2 {
  margin-bottom: 24px;
}

.error-message {
  color: red;
  font-size: 0.9em;
  margin-bottom: 10px;
}

.remember-me {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

button {
  background-color: black;
  border-color: black;
}

button:hover {
  background-color: #333;
  border-color: #333;
}

.verified-icon-size27px {
  width: 27px;
  height: 27px;
}

.ant-btn-color-default.primary-button {
  color: #ffffff;
  height: 35px;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  background: #ff7d4d;
  border-radius: 4px;
  letter-spacing: 1px;
}

.ant-btn-color-default.primary-button:hover {
  background: #ffa07b !important;
  color: #ffffff !important;
  border: unset;
}

.text-bold {
  font-weight: bold;
}

.font-size-14px {
  font-size: 14px;
}

.font-size-18px {
  font-size: 18px;
}

.pointer {
  cursor: pointer;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.instrctions-image {
  width: 100px;
  height: 100px;
  overflow: cover;
}

.font-like-details {
  font-size: 26px;
  font-weight: bold;
  color: #ff7d4d;
  margin-right: 20px;
}

.Category-detail-text {
  display: flex;
  font-size: 18px;
  font-weight: bold;
}

.ant-modal-title {
  font-size: 20px !important;
}

.ant-modal-body{
  font-size: 18px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n/* html,\nbody {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  margin: 0;\n} */\n\n.admin-panel {\n  font-size: 20px;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-center-column {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.flex-center-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-center-evenly {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  gap: 24px;\n}\n\n.breadcrumb {\n  height: 60px;\n  width: 100%;\n  background: #fafafa;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.breadcrumb-logo-font {\n  font-size: 26px;\n  text-align: left;\n  line-height: 1px;\n  padding: 5px;\n  font-weight: bold;\n}\n\n.breadcrumb-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.breadcrumb-logo {\n  width: 250px;\n  height: 80px;\n  background-color: #ff7d4d;\n  color: #fff;\n}\n\n.breadcrumb-right-side {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  padding-right: 20px;\n}\n\n.admin-name {\n  font-size: 14px;\n  color: #252b48;\n}\n\n.admin-role {\n  font-size: 14px;\n  color: #827f86;\n}\n\n.admin-name-role {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex-wrap: nowrap;\n  align-items: start;\n  gap: 4px;\n}\n\n.Sidebar-styles.ant-layout-sider {\n  min-height: calc(100vh - 60px);\n  min-width: 250px;\n}\n\n.flex-column-style {\n  display: flex;\n}\n\n.flex-column-style .flex-grow-content {\n  flex-grow: 1;\n  min-height: 400px;\n  max-height: calc(100vh - 60px);\n  overflow-y: scroll;\n  scrollbar-width: thin;\n}\n\n.dashboard-outer-container {\n  height: 90vh;\n  overflow-y: auto;\n  padding: 20px;\n  background-color: #e8edf7;\n}\n\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  background-color: #f0f2f5;\n}\n\n.login-container {\n  width: 350px;\n  padding: 20px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n\n.login-form h2 {\n  margin-bottom: 24px;\n}\n\n.error-message {\n  color: red;\n  font-size: 0.9em;\n  margin-bottom: 10px;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\nbutton {\n  background-color: black;\n  border-color: black;\n}\n\nbutton:hover {\n  background-color: #333;\n  border-color: #333;\n}\n\n.verified-icon-size27px {\n  width: 27px;\n  height: 27px;\n}\n\n.ant-btn-color-default.primary-button {\n  color: #ffffff;\n  height: 35px;\n  font-size: 16px;\n  font-weight: bold;\n  text-decoration: none;\n  text-align: center;\n  background: #ff7d4d;\n  border-radius: 4px;\n  letter-spacing: 1px;\n}\n\n.ant-btn-color-default.primary-button:hover {\n  background: #ffa07b !important;\n  color: #ffffff !important;\n  border: unset;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n\n.font-size-14px {\n  font-size: 14px;\n}\n\n.font-size-18px {\n  font-size: 18px;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.instrctions-image {\n  width: 100px;\n  height: 100px;\n  overflow: cover;\n}\n\n.font-like-details {\n  font-size: 26px;\n  font-weight: bold;\n  color: #ff7d4d;\n  margin-right: 20px;\n}\n\n.Category-detail-text {\n  display: flex;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.ant-modal-title {\n  font-size: 20px !important;\n}\n\n.ant-modal-body{\n  font-size: 18px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
